// =============================================================
// Gate de versao do build v2.
//
// O rollout do v2 e por cliente, via admcliente.versao (1 = Phada atual,
// 2 = v2). O backend devolve esse campo no login e cada build guarda em
// localStorage.sessionVersao.
//
// Este guard e o espelho do que existe no v1: la, quem tem versao 2 e
// mandado para /v2; aqui, quem NAO tem versao 2 e mandado de volta para a
// raiz. Sem ele, um cliente revertido de 2 para 1 continuaria entrando no
// v2 enquanto a sessao seguisse ativa, porque a decisao so seria refeita
// no proximo login.
//
// Roda no boot, antes do React montar, pelo mesmo motivo do
// impersonationBootstrap: funciona em qualquer rota e evita o flash de
// renderizar a UI errada antes de sair dela.
//
// Nao redireciona quem nao esta logado — senao a tela de login servida em
// /v2 ficaria inacessivel, entrando em laco com a raiz.
// =============================================================

const SK_IS_LOGGED = 'isLogged';
const SK_VERSAO = 'sessionVersao';

// Base do build v1. Mesma origem, por isso o localStorage e compartilhado
// e a sessao sobrevive ao salto entre os dois bundles.
const V1_BASE_PATH = process.env.REACT_APP_V1_BASE_PATH || '/';

export function bootstrapVersaoGuard() {
  try {
    // Sem sessao nao ha decisao a tomar: deixa a tela de login aparecer.
    if (localStorage.getItem(SK_IS_LOGGED) !== 'true') return false;

    // Ausencia de sessionVersao significa sessao aberta por um build
    // anterior a este gate. Tratar como v1 mandaria de volta quem talvez
    // devesse estar aqui; o seguro e nao decidir e deixar o proximo login
    // gravar o campo.
    const bruto = localStorage.getItem(SK_VERSAO);
    if (bruto === null) return false;

    if (Number(bruto) === 2) return false;

    window.location.replace(V1_BASE_PATH);
    return true;
  } catch {
    // localStorage indisponivel (modo privado, storage cheio): nao e
    // motivo para impedir o app de subir.
    return false;
  }
}

export default bootstrapVersaoGuard;
